<template>
  <div>
    <div class="row">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">IndexPage</el-breadcrumb-item>
        <el-breadcrumb-item>Base</el-breadcrumb-item>
        <el-breadcrumb-item>Floor</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="row filter">

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Floor:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.floorName" placeholder=""></el-input>
        </div>
      </div>
    </div>

    <div class="row">
      <el-button type="primary" @click.native="process">Query</el-button>
      <el-button type="primary" @click.native="form.dialogFormVisible = true">New</el-button>
    </div>

    <div class="row">
      <template>
        <el-table
          :data.sync="records"
          stripe
          border
          style="width: 100%">
          <el-table-column
            prop="floorId"
            label="ID"
            width="270px">
          </el-table-column>
          <el-table-column
            prop="floorName"
            label="FLOOR"
            width="270px">
          </el-table-column>

          <el-table-column
            prop="createAt"
            label="CREATE"
            width="270px">
          </el-table-column>

          <el-table-column
            label="OPERATIONS"
            width="270px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="edit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="del(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </template>
    </div>

    <div class="row">
      <el-pagination
        @size-change="process"
        @current-change="process"
        :current-page.sync="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>


    <!-- new form-->
    <div class="row">
      <el-dialog :title="form.floorId == 0 ? '新增floor':'修改floor'" :visible.sync="form.dialogFormVisible" @close="close">

        <input hidden v-model="form.floorId">

        <el-form :model="form" ref="form" label-width="100px" class="demo-ruleForm"
                 :rules="{floorName:[{required:true,message:'请输入名称',trigger:'blur'}]}" action="/floor/addOrEdit">
          <el-form-item label="Name" prop="floorName">
            <el-input v-model="form.floorName"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="form.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>


  </div>
</template>

<script>
  export default {
    name: "Floor",
    data: function () {
      return {
        filter: {},
        records: [],
        total: 0,
        page: {
          pageSize: 10,
          currentPage: 1
        },
        form: {
          floorName: '',
          floorId:null,
          labelWidth: '120px',
          dialogFormVisible: false,
        }
      };
    },
    created: function () {
      this.process();
    },
    methods: {
      close:function () {
        this.form.floorId = null;
        this.form.floorName = "";
      },
      process: function () {
        this.$http.post("/floor/list", {
          filter: this.filter,
          pageSize: this.page.pageSize,
          currentPage: this.page.currentPage
        }).then(response => {
          this.records = response.data.data.data;
          this.total = response.data.data.total;
        });
      },
      submit: function () {
        this.$refs.form.validate(
          validate => {
            if (!validate) {
              return false;
            }
            this.$http.post(this.$refs['form'].$attrs.action, {
              floorName: this.form.floorName,
              floorId:this.form.floorId
            }).then(response => {
              if (response.data.code == "1") {
                this.form.dialogFormVisible = false;
                this.$message.success("操作成功");
                this.process();
                return true;
              }
            });
          }
        );
      },
      edit:function (index,row) {
        this.form.floorId = row.floorId;
        this.form.floorName = row.floorName;
        this.form.dialogFormVisible =true;
      },
      del:function (index,row) {
        this.$confirm('确定删除该记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          this.$http.post("/floor/delete",{
            floorId: row.floorId,
          }).then(response=>{
            if(response.data.code == "1"){
              this.$message.success("删除成功");
              this.process();
            }
          })
        });

      }
    }
  }
</script>

<style scoped>

  .filter {
    border: 1px solid #DCDFE6;
  }

  .filter > .filter-item {
    border-bottom: 1px dashed #DCDFE6;
    position: relative;
    display: block;
    padding: 5px 0 5px 0;
  }

  .filter > .filter-item:last-of-type {
    border-bottom: none;
  }

  .filter > .filter-item > .item-head {
    display: inline-block;
    width: 150px;
    float: left;
    line-height: 32px;
    padding-left: 10px;
  }

  .filter > .filter-item > .item-content {
    display: block;
    float: left;
    margin-left: 10px;
  }

  .clear {
    display: block;
    overflow: hidden;
  }


</style>



// WEBPACK FOOTER //
// src/components/base/Floor.vue